import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Flex } from '@chakra-ui/react';
import ArticlesList from './articles-list';
import Pagination from './pagination';
import Sidebar from './sidebar';
/* eslint-disable-next-line */

export function PublicationHub(props) {
  var _props$organization, _props$organization2, _props$organization3, _props$organization4, _props$organization5, _props$organization5$, _props$organization5$2;

  return /*#__PURE__*/_jsxs(Flex, {
    direction: ['column', 'row'],
    py: 8,
    children: [/*#__PURE__*/_jsx(Box, {
      w: ['100%', '30%'],
      py: "3",
      children: /*#__PURE__*/_jsx(Box, {
        style: {
          position: 'sticky',
          top: '50px'
        },
        children: /*#__PURE__*/_jsx(Sidebar, {
          organization: {
            id: (_props$organization = props.organization) === null || _props$organization === void 0 ? void 0 : _props$organization.id,
            name: (_props$organization2 = props.organization) === null || _props$organization2 === void 0 ? void 0 : _props$organization2.name,
            logo_url: (_props$organization3 = props.organization) === null || _props$organization3 === void 0 ? void 0 : _props$organization3.logo_url,
            slug: (_props$organization4 = props.organization) === null || _props$organization4 === void 0 ? void 0 : _props$organization4.slug,
            url: (_props$organization5 = props.organization) === null || _props$organization5 === void 0 ? void 0 : (_props$organization5$ = _props$organization5.data) === null || _props$organization5$ === void 0 ? void 0 : (_props$organization5$2 = _props$organization5$.links) === null || _props$organization5$2 === void 0 ? void 0 : _props$organization5$2.website_url
          },
          publishersCount: props.researchersCount,
          publicationsCount: props.publicationsCount
        })
      })
    }), /*#__PURE__*/_jsxs(Box, {
      w: ['100%', '70%'],
      py: "3",
      children: [/*#__PURE__*/_jsx(ArticlesList, {
        articles: props.articles
      }), /*#__PURE__*/_jsx(Box, {
        mt: 5,
        align: "center",
        overflowX: "scroll",
        children: /*#__PURE__*/_jsx(Pagination, {
          range: 2,
          numOfPages: props.totalPages,
          currentPage: props.currentPage,
          slug: props.organization.slug
        })
      })]
    })]
  });
}
export default PublicationHub;